import { Injectable } from "@angular/core";

import { IByRoom, ICreateBooking, IDetail } from "libraries/service/resources/model/search/IBooking";
import { IHotelQuoteDetail } from "libraries/service/resources/hotel/hotel-quotation";
import { IRoomDetail, RoomCode, RoomStatus } from "libraries/hotel/models/quote";
import { IBookingRoom } from "libraries/hotel/models/booking";
import { IPenalty } from "../../../service/resources/hotel/IResourceHotel";
import { IGetBookingsStayResponse, IService } from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IMealplan } from "libraries/hotel/models/details";

@Injectable()
export class RoomService {

    private roomsModel: IHotelQuoteDetail[];

    public get rooms(): IHotelQuoteDetail[] {
        return this.roomsModel;
    }

    public set rooms(accommodation: IHotelQuoteDetail[]) {
        this.roomsModel = accommodation;
    }

    public formatRoomsDetailFromQuote(accommodationsDetails: IHotelQuoteDetail[], total: { cost: { [key: string]: number } } = null): IRoomDetail[] {
        return accommodationsDetails.map((accoDetail: IHotelQuoteDetail): IRoomDetail => {
            return {
                code: accoDetail.room.code,
                host: accoDetail.room.host,
                name: accoDetail.name,
                penalty: accoDetail.room.penalty ? accoDetail.room.penalty as IPenalty : null,
                syscode: accoDetail.room.syscode,
                xCode: accoDetail.room.xCode as RoomCode,
                xId: accoDetail.room.xId,
                unit: accoDetail.unit.cost ? Object.values(accoDetail.unit.cost)[0] : null,
                total,
                mealplan: accoDetail.room.mealplan ? accoDetail.room.mealplan : null,
                dateLastCancellationWithoutPenalty: accoDetail.dateLastCancellationWithoutPenalty ? accoDetail.dateLastCancellationWithoutPenalty : null,
                status: accoDetail.status,
            };
        });
    }

    public formatRoomsDetailFromBooking(accommodationsDetails: IBookingRoom[], booking:  Partial<IGetBookingsStayResponse>): IRoomDetail[] {
        return accommodationsDetails.map((accoDetail: IBookingRoom, index: number): IRoomDetail => {
            // const price = Array.isArray(booking.price) ? booking.price[0] : booking.price;
            //
            // const priceDetailArray: IDetail[] = price.detail as IDetail[];
            // const priceDetail: IDetail = price.detail as IDetail || null;
            // const totalDetail: IDetail = priceDetailArray.length > 0 ? priceDetailArray[index] : priceDetail;

            const serviceWithMealplan: IService = booking.service.find((serviceItem: IService): boolean => Boolean(serviceItem.mealplan));
            const mealplan: IMealplan = serviceWithMealplan ? {
                xId: serviceWithMealplan.xId,
                syscode: serviceWithMealplan.syscode,
                code: serviceWithMealplan.code,
                xStatus: serviceWithMealplan.xStatus,
                name: {
                    text: serviceWithMealplan.name,
                    language: serviceWithMealplan.language,
                }
            }: null;
            return {
                code: accoDetail.code,
                host: booking.host,
                name: accoDetail.name,
                penalty: accoDetail.penalty ? accoDetail.penalty : null,
                syscode: accoDetail.syscode,
                xCode: accoDetail.xCode as RoomCode,
                xId: accoDetail.xId,
                total: {
                    cost: {
                        [booking.total[0].currency]: booking.total[0].value,
                    }
                },
                mealplan,
                dateLastCancellationWithoutPenalty: booking.whenLastToCancelWithoutPenalty ? booking.whenLastToCancelWithoutPenalty : null,
                status: RoomStatus.Available,
            };
        });
    }

    public createMapByRoom<TResult extends IByRoom>(elements: TResult | TResult[]): Map<string, TResult> {
        if (elements) {
            const list: TResult[] = Array.isArray(elements) ? elements : [elements];

            return list.reduce((map: Map<string, TResult>, element: TResult) => {
                map.set(element.room, element);
                return map;
            }, new Map());
        }

        return new Map();
    }
}
